import React from 'react';
import {Toaster} from '@learningblocks/storybook-components';

export const MIN_TUBES_FOR_BALANCE = 2;

export const TUBE_TYPES = {
  PCR: 'PCR',
  NON_PCR: 'NON_PCR',
};

export const NOTIFY_EVENTS = {
  LID_NOT_CLOSED: {
    title: 'Lid Open!',
    message: 'This operation is not performed while centrifuge lid is open.',
  },
  NOT_BALANCED: {
    title: 'Not Balanced!',
    message: 'This operation requires for the centrifuge to be balanced',
  },
  NOT_ALLOWED: {
    title: 'Centrifuge Running!',
    message: 'This operation is not allowed while centrifuge is running',
  },
  ERROR_DEFAULT: {
    title: 'Error !',
    message: 'An error occured.',
  },
};

export function getTimeValues(date) {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  return [seconds, minutes, hours];
}

export function isTimeEqual(dateOne, dateTwo) {
  const [s1, m1, h1] = getTimeValues(dateOne);
  const [s2, m2, h2] = getTimeValues(dateTwo);
  return s1 === s2 && m1 === m2 && h1 === h2;
}

export function getNewTime(currentTime, rate) {
  const currentSeconds = currentTime.getSeconds();
  const newTime = new Date(currentTime.getTime());
  newTime.setSeconds(currentSeconds + rate);
  return newTime;
}

export function isRunningComplete(timeLeft) {
  return getTimeValues(timeLeft).every((v) => v <= 0);
}

export const FRONTVIEW_SLOT_INDICES = [0, 1, 2, 3, 4];

export function useMicrocentrifuge(props, alert) {
  const alertError = (params) =>
    alert({
      ...NOTIFY_EVENTS.ERROR_DEFAULT,
      ...params,
      type: Toaster.Types.ERROR,
    });

  const isNotRunning = (callback) => {
    if (props.running) alertError(NOTIFY_EVENTS.NOT_ALLOWED);
    else callback();
  };

  const isCentrifugeRunnable = (callback) => {
    if (props.running) {
      alertError(NOTIFY_EVENTS.NOT_ALLOWED);
    } else if (props.isOpen) {
      alertError(NOTIFY_EVENTS.LID_NOT_CLOSED);
    } else if (!props.balanced) {
      alertError(NOTIFY_EVENTS.NOT_BALANCED);
    } else {
      callback();
    }
  };

  return {
    alertError,
    isNotRunning,
    isCentrifugeRunnable,
  };
}
